import PropTypes from "prop-types"
import { DATE } from "helpers/shapes"

const RISK_CATEGORY_SHAPE = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  listFactors: PropTypes.bool,
  formatter: PropTypes.func.isRequired,
  scaleFormatter: PropTypes.func.isRequired,
}

export const RISK_CATEGORY = PropTypes.shape(RISK_CATEGORY_SHAPE)

export const RISK_TREND = PropTypes.shape({
  data: PropTypes.arrayOf(PropTypes.shape({
    date: DATE.isRequired,
    value: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
  })).isRequired,
  ...RISK_CATEGORY_SHAPE,
})
